var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGtbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2080_7214)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.729004H26V27.0423H0V0.729004Z",
    fill: "#D94F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7927 5.83154H21.4578V12.5101H14.7927V5.83154ZM6.73494 15.8883V16.5417H7.88368V19.9982H8.67577V16.5153H9.7453V15.8619L6.73494 15.8888V15.8883ZM6.14334 16.6983V16.0449C5.50788 15.7576 4.77711 15.6708 4.02888 16.0449C2.80182 16.5936 2.75797 19.3104 3.98547 19.8416C4.69029 20.1987 6.16034 20.0331 6.30847 19.7194V17.5687H4.84692V18.1348H5.49043V19.267C3.37597 20.2944 2.98441 15.3571 6.14334 16.6983ZM11.0337 18.0999H11.7904C12.4169 18.1263 12.5825 19.3104 11.7644 19.3014H11.0337V18.0999ZM11.0337 16.4369H11.7904C12.4169 16.5502 12.1909 17.4819 11.7644 17.5078H11.0337V16.4369ZM10.2505 15.8015V19.9633H12.3301C13.3916 19.5802 13.4354 17.9347 12.3301 17.7602C13.3482 17.6474 13.4005 15.7751 11.6427 15.7751L10.2505 15.8015ZM13.9223 16.9681V17.5861C14.479 17.4295 15.6886 16.9941 15.5754 17.9173C14.5139 17.8475 13.7916 18.039 13.6699 18.7004C13.4699 20.1289 15.0012 20.268 15.6452 19.5628V19.9024H16.376V17.3946C16.1934 16.5846 14.9842 16.4804 13.9223 16.9681ZM14.5399 18.5792C14.7054 18.3612 15.2362 18.3697 15.5928 18.4744V19.0231C15.0102 19.6496 14.0704 19.3627 14.5403 18.5787L14.5399 18.5792ZM17.8903 17.7083C18.0819 17.4993 19.0999 17.1073 19.2566 17.7083V19.9199H20.0741V17.5776C19.9001 16.6021 18.9688 16.428 17.838 17.0899V16.7242H17.0638V19.9373H17.8814L17.8903 17.7083ZM22.641 16.6893L21.571 18.1258L22.7023 19.8935L23.6855 19.8675L22.4414 18.1697L23.5638 16.7153L22.6415 16.6893H22.641ZM20.6836 15.6355H21.4927V19.8935H20.6832V15.6359L20.6836 15.6355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7927 5.83154H21.4579V12.5101H14.7927V5.83154Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2080_7214"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26.3133,
    fill: "white",
    transform: "translate(0 0.729004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGtbank);
export default __webpack_public_path__ + "static/media/gtbank.87d143fcd60e9982cd1c8e35afe9d1b6.svg";
export { ForwardRef as ReactComponent };